import { toReaderLocale } from './numberFormat';

/** Names joined as the reader's language joins them: "A, B et C" in French, "A, B, and C" in English. */
export const formatNameList = (names: string[], language: string): string =>
    new Intl.ListFormat(toReaderLocale(language), { type: 'conjunction' }).format(names);
